import { Component } from '@angular/core';

@Component({
    selector: 'tr-wrapper-left-column',
    template: `<div class="tr-wrapper-column--left">
        <ng-content></ng-content>
    </div>`,
})
export class TrWrapperLeftColumnComponent {}
